<div class="modal-overlay" *ngIf="isVisible" (click)="onClose()">
  <div class="modal-content" (click)="onModalContentClick($event)">
    <!-- Header -->
    <div class="modal-header">
      <div class="header-content">
        <h2 class="modal-title">Reschedule appointment</h2>
        <button class="close-button" (click)="onClose()">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 5L5 15M5 5L15 15" stroke="#15172E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
    </div>

    <!-- Information Banner -->
    <div class="info-banner">
      <div class="info-icon">
        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="8.5" cy="8.5" r="7.08" fill="#717683"/>
          <path d="M8.5 5.67V8.5M8.5 11.33V8.5" stroke="white" stroke-width="1.7" stroke-linecap="round"/>
        </svg>
      </div>
      <div class="info-text">
        <p>The appointment duration is {{ getAppointmentDuration() }}. You can edit the time from the appointment details screen if needed.</p>
      </div>
    </div>
    <div class="">
      <div class="notify" *ngIf="showShopTimezoneWarning">
        <p> <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="8.99935" cy="9.00033" r="8.33333" fill="#F57600"/>
          <path d="M8.99203 11.5H8.99951" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M9 9L9 5.66667" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          Appointment times are shown and scheduled in the selected location's time zone.</p>
      </div>
      <div class="notify">
        <p> <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="8.99935" cy="9.00033" r="8.33333" fill="#F57600"/>
          <path d="M8.99203 11.5H8.99951" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M9 9L9 5.66667" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
           Bookings are allowed only for available workdays and time slots; other times are disabled.</p>
      </div>
    </div>

    <!-- Content -->
    <div class="modal-body">
      <div class="calendar-container">
        <div class="calendar-wrapper">
          <div class="calendar-content">
            <!-- Calendar Section -->
            <div class="calendar-section">
              <div class="calendar-header">
                <div class="calendar-nav">
                  <button class="nav-btn" (click)="previousMonth()">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12.5 15L7.5 10L12.5 5" stroke="#15172E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </button>
                  <span class="current-month">{{ getCurrentMonthYear() }}</span>
                  <button class="nav-btn" (click)="nextMonth()">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M7.5 15L12.5 10L7.5 5" stroke="#15172E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </button>
                </div>
              </div>

              <div class="calendar-body">
                <!-- Day headers -->
                <div class="calendar-days">
                  <div class="day-header" *ngFor="let day of weekDays; trackBy: trackByIndex">{{ day }}</div>
                </div>

                <!-- Calendar grid -->
                <div class="calendar-grid">
                <div 
                  class="calendar-day" 
                  *ngFor="let day of calendarDays; trackBy: trackByIndex" 
                  [class.other-month]="!day.isCurrentMonth"
                  [class.selected]="isSelectedDate(day.date)"
                  [class.today]="isToday(day.date)"
                  [class.off-day]="day.isOffDay"
                  [class.past-date]="isDateDisabled(day.date)"
                  (click)="onDateSelect(day.date)"
                  [class.disabled]="!day.isCurrentMonth || isDateDisabled(day.date)">
                  {{ day.dayNumber }}
                </div>
                </div>
              </div>
            </div>

            <!-- Time Picker Section -->
            <div class="time-picker-section">
              <div class="time-picker-header">
                <h3>Choose Time</h3>
              </div>
              <div class="time-slots-container">
                <div class="time-slots-scroll">
                  <div 
                    class="time-slot" 
                    *ngFor="let slot of timeSlots; trackBy: trackByIndex"
                    [class.selected]="isTimeSlotSelected(slot)"
                    [class.available]="selectedDate ? isTimeSlotAvailable(slot, selectedDate) : false"
                    [class.unavailable]="!selectedDate || !isTimeSlotAvailable(slot, selectedDate)"
                    (click)="onTimeSelect(slot)">
                    {{ slot.displayTime }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="modal-footer">
      <div class="footer-content">
        <button class="btn btn-outline" (click)="onClose()">
          Cancel
        </button>
        <button 
          class="btn btn-primary btn-medium" 
          (click)="onUpdate()"
          [class.disabled]="!hasDateTimeChanged() || loading"
          [disabled]="!hasDateTimeChanged() || loading">
          <span *ngIf="loading">Updating...</span>
          <span *ngIf="!loading">Update</span>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Off Days Modal -->
<div class="off-days-modal-overlay" *ngIf="showOffDaysModal" (click)="onCloseOffDaysModal()">
  <div class="off-days-modal-content" (click)="onModalContentClick($event)">
    <!-- Header -->
    <div class="off-days-modal-header">
      <div class="off-days-header-content">
        <h2 class="off-days-modal-title">Outside Operating Days</h2>
        <button class="off-days-close-button" (click)="onCloseOffDaysModal()">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 5L5 15M5 5L15 15" stroke="#15172E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
    </div>

    <!-- Body -->
    <div class="off-days-modal-body">
      <p class="off-days-message">
        You've selected a date that falls outside the shop's regular working days. Do you want to proceed with this appointment or choose a different day?
      </p>
    </div>

    <!-- Footer -->
    <div class="off-days-modal-footer">
      <div class="off-days-footer-content">
        <button class="btn btn-outline" (click)="onChooseAnotherDay()">
          Choose Another Day
        </button>
        <button class="btn btn-primary" (click)="onProceedAnyway()">
          Proceed Anyway
        </button>
      </div>
    </div>
  </div>
</div>
